import Account from 'lib/auth/Account';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { mySystemSettingsApi } from 'v5/api/system-settings/system-settings.api.connected';
import { createSystemSettingsService } from './SystemSettingsService.impl';

export const mySystemSettingsService = createSystemSettingsService({
  api: mySystemSettingsApi,
  queryClient,
  reduxProxy: myReduxProxy,
  resolveCurrentWorkspace: () => Account.resolveFirstWorkspace()
});
